module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10196.7d345cc7.jpg";